module.exports = __webpack_public_path__ + "img/PA.f8b9cb78.png";